import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useSeo, FAQS } from "@/lib/site";
import { MaskLines, Reveal } from "@/components/Reveal";

export default function Faq() {
  useSeo("FAQ — Lead Times, Council, Delivery & More | Breeze Craft Sydney", "Straight answers on breeze block lead times, engineering and council responsibility, delivery, damage policy and render options.");
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-14 sm:py-20" data-testid="faq-page">
      <p className="kicker mb-4">FAQ</p>
      <h1 className="font-display text-4xl sm:text-6xl font-medium tracking-tight text-ink" data-testid="faq-heading">
        <MaskLines lines={["No fluff.", "Just answers."]} />
      </h1>
      <Reveal delay={0.2} className="mt-12">
        <Accordion type="single" collapsible className="border-t border-ink/10" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`q-${i}`} className="border-b border-ink/10">
              <AccordionTrigger data-testid={`faq-question-${i}`} className="text-left font-display text-lg font-medium text-ink hover:text-terracotta hover:no-underline py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-neutral-600 leading-relaxed pb-6 max-w-2xl">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  );
}
